import type { AlumnusDetails } from '../models/alumniDetails';
import { requests } from '../../../app/api/httpClient';

export const Alumni = {
    getAlumniDetails: (personId: string) => requests.get(`Alumni/${personId}`),
    updateAlumniDetails: (data: AlumnusDetails) => requests.put(`Alumni`, data)
};
